export const CLOUDINARY = 'cloudinary.com'
export const BLAZE_COMPANY = 'BLAZE'
export const BLAZE_ECOMMERCE = `${BLAZE_COMPANY} ECOM`
export const GREENLINE_LOYALTY = `${BLAZE_COMPANY} Loyalty`
export const PAYMENT_FEE = 'Payment Fee'
